import { useMutation, useQueryClient } from 'react-query';

import { http } from '@/api/base/http';

export const useDeleteVariant = (args: Record<string, unknown> = {}) => {
    return useMutation({
        mutationFn: (id: number) => http.delete<void>(`/variants/${id}`),
        ...args,
    });
};
